<div class="user-dropdown">
  <button 
    class="user-dropdown__trigger"
    (click)="toggleDropdown()"
    aria-label="Menú de usuario"
    [attr.aria-expanded]="isOpen()">
    <span class="user-dropdown__initials">{{ userInitials() }}</span>
  </button>

  @if (isOpen()) {
    <div class="user-dropdown__menu">
      <div class="user-dropdown__header">
        <div class="user-dropdown__avatar">
          <span>{{ userInitials() }}</span>
        </div>
        <div class="user-dropdown__info">
          <div class="user-dropdown__name">{{ userName() }}</div>
          <div class="user-dropdown__role">{{ userRole() }}</div>
        </div>
      </div>
      
      <div class="user-dropdown__divider"></div>
      
      <button class="user-dropdown__logout" (click)="logout()">
        <svg class="user-dropdown__logout-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.75 6L11.6925 7.0575L12.8775 8.25H6.75V9.75H12.8775L11.6925 10.935L12.75 12L15.75 9L12.75 6ZM3.75 3.75H9V2.25H3.75C2.925 2.25 2.25 2.925 2.25 3.75V14.25C2.25 15.075 2.925 15.75 3.75 15.75H9V14.25H3.75V3.75Z" fill="#0E98F0"/>
        </svg>
        <span>Cerrar sesión</span>
      </button>
    </div>
  }
</div>